import http from './httpClient';

export const ExpiryThresholdsApi = {
  /**
   * Get all inventory items with expiry threshold status
   */
  async listInventoryItemThresholds() {
    const response = await http.get('/expiry-thresholds/inventory-items');
    return response.data || [];
  },
  
  /**
   * Update/create expiry threshold for an inventory item
   * @param {number} itemId - Inventory item ID
   * @param {object} payload - { expiry_required, days_before_expiry_alert, is_active }
   */
  async updateInventoryItemThreshold(itemId, payload) {
    const response = await http.put(`/expiry-thresholds/inventory-items/${itemId}`, payload);
    return response.data;
  },
  
  /**
   * Bulk initialize expiry thresholds for all inventory items
   * @param {number} default_days_alert - Default days before expiry to alert
   * @param {boolean} enable_all - Enable expiry requirement for all items
   */
  async initInventoryItemThresholds(default_days_alert = 7, enable_all = false) {
    return http.post('/expiry-thresholds/inventory-items/initialize', { 
      default_days_alert, 
      enable_all 
    });
  },
  
  /**
   * Check if expiry is required for a specific item
   * @param {number} itemId - Inventory item ID
   */
  async checkExpiryRequirement(itemId) {
    const response = await http.get(`/expiry-thresholds/check-requirement/${itemId}`);
    return response;
  },
  
  /**
   * Get statistics about expiry thresholds
   */
  async getStats() {
    const response = await http.get('/expiry-thresholds/stats');
    return response.stats || {};
  }
};

export default ExpiryThresholdsApi;
